export const ERROR_MESSAGES = {
  UNEXPECTED: 'An unexpected error occurred.',
  TOKEN_EXPIRED: 'Token expired',
  UNAUTHORIZED: 'Unauthorized',
  SUBMIT_QUESTION_NETWORK_ERROR:
    'There was a network error while submitting your question. Please try again.',
  EMAIL_UNVERIFIED: 'Email is not verified',
  CONVERSATION_NOT_FOUND: 'Conversation not found',
  FAILED_TO_FETCH: 'Failed to fetch',
  NETWORK_ERROR: 'Something went wrong. Please check your network connection and try again.',
  FAILED_TO_SEND_MESSAGE_WHILE_NETWORK_ERROR:
    'Something went wrong while sending your message. Check your connection and try again.',
  QUESTION_ALREADY_ANSWERED: 'Question has already been answered',
  ORGANIZATION_INVITE_NOT_ACCEPTED: 'Organization invite has not been accepted',
  INVALID_ROLE: 'User has invalid role',
  NOT_ORGANIZATION_MEMBER: 'User is not member of organization',
  PROJECT_RESPONDENT_EXCEEDED: 'Project participant count exceeded',
  PROJECT_IS_COMPLETED: 'Project is completed',
  PROJECT_NOT_PUBLISHED: 'Project is not published',
  VERIFICATION_EMAIL_ALREADY_SENT:
    'Verification email was already sent. Please wait 24 hours before requesting another one.',
};
